var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2FD2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.57 4.007A11.788 11.788 0 009.058 6.38a1.765 1.765 0 00-.11 2.732c.622.588 1.58.634 2.256.109a8.386 8.386 0 0111.294.91c.59.61.608 1.571.042 2.203a1.588 1.588 0 01-2.245.078l-.077-.078a5.238 5.238 0 100 7.059 1.556 1.556 0 011.86-.353 1.578 1.578 0 01.462 2.47 8.414 8.414 0 01-11.34.996 1.765 1.765 0 00-2.27.11 1.786 1.786 0 00.149 2.756 11.852 11.852 0 107.49-21.364zm-.22 14.788a2.933 2.933 0 11.022-5.866 2.933 2.933 0 01-.021 5.866z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmm);
export default __webpack_public_path__ + "static/media/cmm.1f0286a4e44ad6def6a7cc0cb1da79c0.svg";
export { ForwardRef as ReactComponent };